import React from 'react';

function Process() {
  const steps = [
    {
      number: "01",
      title: "Consultation",
      description: "Understanding client needs and requirements.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      )
    },
    {
      number: "02",
      title: "Planning",
      description: "Developing a tailored logistics strategy.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      )
    },
    {
      number: "03",
      title: "Execution",
      description: " Implementing the logistics plan with precision.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      number: "04",
      title: "Monitoring",
      description: "Tracking shipments and ensuring timely delivery.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      )
    },
    {
      number: "05",
      title: "Feedback",
      description: "Collecting client feedback for continuous improvement.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    }
  ];

  return (
    <section id="process" className="section-padding bg-ash-dark">
      <div className="container-custom">
        {/* Section header */
}
        <div className="text-center mb-16">
          <h2 className="heading-secondary mb-6">
            Our <span className="text-red">Process</span>
          </h2>
          <p className="text-xl text-gray-light max-w-3xl mx-auto">
            Streamlined workflow designed for efficiency and transparency. 
            We ensure every step of your re-export journey is handled with precision.
          </p>
        </div>

        {/* Process steps */}
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute left-1/2 top-20 bottom-20 w-0.5 bg-gradient-to-b from-red/20 to-orange/20 transform -translate-x-px"></div>
          
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className={`flex flex-col lg:flex-row items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Step number and content */}
                <div className={`w-full lg:w-1/2 ${index % 2 === 0 ? 'lg:pr-16' : 'lg:pl-16'}`}>
                  <div className="bg-ash rounded-2xl p-8 border border-red/20">
                    <div className="flex items-start mb-6">
                      <div className="w-16 h-16 bg-gradient-to-r from-red to-orange rounded-xl flex items-center justify-center mr-6">
                        <div className="text-white">{step.icon}</div>
                      </div>
                      <div>
                        <div className="text-3xl font-bold text-red mb-2">{step.number}</div>
                        <h3 className="text-2xl font-semibold text-white">{step.title}</h3>
                      </div>
                    </div>
                    <p className="text-gray-light text-lg leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
                
                {/* Visual element */}
                <div className="hidden lg:flex w-1/2 justify-center">
                  <div className="relative">
                    <div className="w-24 h-24 rounded-full bg-gradient-to-r from-red to-orange flex items-center justify-center">
                      <span className="text-2xl font-bold text-white">{step.number}</span>
                    </div>
                    <div className="absolute inset-0 rounded-full border-4 border-red/30 animate-ping"></div>
                  </div>
                </div>
                
                {/* Mobile step number */}
                <div className="lg:hidden w-full mt-6">
                  <div className="flex justify-center">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-r from-red to-orange flex items-center justify-center">
                      <span className="text-xl font-bold text-white">{step.number}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;